import { ReactNode, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { User } from '@domain/user';
import { PUBLIC_PAGE_TOKEN } from '@utils/token/constants';
import { removePublicPageToken } from '@utils/token/remove-public-page-token';
import { setPublicPageToken } from '@utils/token/set-public-page-token';

import { SHARED_REPORT_TOKEN_QUERY_PARAM } from './user.type';
import { UserContext } from './user-context';

export const UserProvider = ({ children }: { children: ReactNode }) => {
  const [searchParams] = useSearchParams();
  const sharedReportToken = searchParams.get(SHARED_REPORT_TOKEN_QUERY_PARAM);
  const [userState, setUserState] = useState<User | null>(null);
  const [isUserLoading, setIsUserLoading] = useState<boolean>(!sharedReportToken);
  if (sharedReportToken) setPublicPageToken({ key: PUBLIC_PAGE_TOKEN, token: sharedReportToken });
  else removePublicPageToken({ key: PUBLIC_PAGE_TOKEN });
  return (
    <UserContext.Provider value={{ userState, setUserState, isUserLoading, setIsUserLoading }}>
      {children}
    </UserContext.Provider>
  );
};
